import '@toast-ui/editor/dist/toastui-editor-viewer.css';
import { Viewer } from '@toast-ui/react-editor';
import { useEffect, useRef } from 'react';

export const ToastViewer = ({ content }: { content: string }) => {
  const viewerRef = useRef<Viewer>(null);

  useEffect(() => {
    if (viewerRef && viewerRef.current) {
      viewerRef.current?.getInstance().setMarkdown(content);
    }
  }, [content]);

  return (
    <div>
      <Viewer
        ref={viewerRef}
        initialValue={content}
        customHTMLRenderer={{
          htmlBlock: {
            iframe(node: any) {
              return [
                {
                  type: 'openTag',
                  tagName: 'div',
                  outerNewLine: true,
                  attributes: { class: 'youtubeWrapper' },
                },
                {
                  type: 'openTag',
                  tagName: 'iframe',
                  outerNewLine: true,
                  attributes: node.attrs,
                },
                { type: 'html', content: node.childrenHTML },
                {
                  type: 'closeTag',
                  tagName: 'iframe',
                  outerNewLine: false,
                },
                {
                  type: 'closeTag',
                  tagName: 'div',
                  outerNewLine: false,
                },
              ];
            },
          },
        }}
      />
    </div>
  );
};
